export const UNDERSTOOD = "UNDERSTOOD";
export const COMPLETED = "completed";
export const USER_CANCELLED = "user cancelled";
export const ACCESS_DENIED = "access denied";

export enum UPLOAD_AADHAR_STATE {
    IN_APP_KYC = "com.android.chrome:id/in_app_kyc",
    DIGILOCKER_KYC = "com.android.chrome:id/digilocker_kyc",
}
